module.exports = __webpack_public_path__ + "static/media/truck-fast-solid.543d7f38.svg";